export default __webpack_public_path__ + "static/media/kitchen_color.fa1f89ce.svg";